"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_router_dom_1 = require("react-router-dom");
var Menu_1 = __importDefault(require("@mui/icons-material/Menu"));
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var MailOutline_1 = __importDefault(require("@mui/icons-material/MailOutline"));
var trans_1 = __importDefault(require("@/plugins/trans"));
var ChatOutlined_1 = __importDefault(require("@mui/icons-material/ChatOutlined"));
var Apartment_1 = __importDefault(require("@mui/icons-material/Apartment"));
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var ArrowRightIcon_1 = __importDefault(require("../icons/ArrowRightIcon"));
var Link_1 = __importDefault(require("../components/Link"));
var MobileMenu_1 = __importDefault(require("./MobileMenu"));
var UserContext_1 = __importDefault(require("../context/UserContext"));
var AccountMenu_1 = __importDefault(require("./AccountMenu"));
var MenuItem_1 = __importStar(require("./MenuItem"));
var NotificationBadge_1 = __importDefault(require("../components/NotificationBadge"));
var NotificationContext_1 = __importDefault(require("../context/NotificationContext"));
var BookmarkedContext_1 = __importDefault(require("../context/BookmarkedContext"));
var bookmarkedBubbleStyle_1 = __importDefault(require("./bookmarkedBubbleStyle"));
var classes = {
    activeLink: {
        textDecoration: 'underline',
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    spacing: {
        '&>*+*': {
            marginLeft: '1rem',
        },
    },
    menuIcon: {
        color: function (theme) { return theme.palette.primary.main; },
        fontSize: '32px',
    },
    userImage: {
        width: 30,
        height: 30,
        objectFit: 'cover',
        borderRadius: '50%',
    },
};
var TopBar = function () {
    var isSmallScreen = (0, material_1.useMediaQuery)('only screen and (max-width: 990px)');
    var _a = (0, react_1.useContext)(UserContext_1.default), userId = _a.userId, userImageSrc = _a.userImageSrc;
    var notifications = (0, react_1.useContext)(NotificationContext_1.default).notifications;
    var bookmarks = (0, react_1.useContext)(BookmarkedContext_1.default).bookmarks;
    var theme = (0, material_1.useTheme)();
    var isHomePage = (0, react_router_dom_1.useMatch)({ path: '/', end: true });
    var isVacanciesPage = (0, react_router_dom_1.useMatch)('/vacancies');
    var isJobAlertsPage = (0, react_router_dom_1.useMatch)('/vacancy-alerts');
    var isYourVacanciesPage = (0, react_router_dom_1.useMatch)('/saved-vacancies');
    var isMyApplicationsPage = (0, react_router_dom_1.useMatch)('/my-applications');
    var isConnectionsPage = (0, react_router_dom_1.useMatch)('/connections/*');
    var _b = (0, react_1.useState)(false), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    var _c = (0, react_1.useState)(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var unreadChats = (0, react_1.useMemo)(function () {
        return !!Object.keys(notifications.conversations).length;
    }, [notifications]);
    var handleClick = (0, react_1.useCallback)(function (event) {
        setAnchorEl(event.currentTarget);
    }, []);
    var handleClose = (0, react_1.useCallback)(function () {
        setAnchorEl(null);
    }, []);
    var toggleMenu = (0, react_1.useCallback)(function () {
        setIsMenuOpen(function (prev) { return !prev; });
    }, [setIsMenuOpen]);
    var title = (0, react_1.useMemo)(function () {
        if (isHomePage) {
            return 'Home';
        }
        if (isVacanciesPage) {
            return trans_1.default.get('entities.vacancies');
        }
        if (isJobAlertsPage) {
            return trans_1.default.get('entities.vacancy_alerts');
        }
        if (isYourVacanciesPage) {
            return trans_1.default.get('labels.frontend.general.saved_vacancies');
        }
        if (isMyApplicationsPage) {
            return trans_1.default.get('labels.frontend.general.my_applications');
        }
        if (isConnectionsPage) {
            return trans_1.default.get('entities.connections');
        }
        return null;
    }, [isHomePage, isMyApplicationsPage, isVacanciesPage, isJobAlertsPage, isYourVacanciesPage]);
    var closeMenu = (0, react_1.useCallback)(function () {
        setIsMenuOpen(false);
    }, []);
    (0, react_1.useEffect)(function () {
        if (isMenuOpen) {
            document.body.classList.add('menu-open');
        }
        else {
            document.body.classList.remove('menu-open');
        }
    }, [isMenuOpen]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Container, __assign({ maxWidth: "lg" }, { children: (0, jsx_runtime_1.jsx)("nav", __assign({ role: "navigation", css: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: isSmallScreen ? 12 : 50,
                        height: isSmallScreen ? 50 : 80,
                    } }, { children: isSmallScreen ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Link_1.default, __assign({ onClick: closeMenu, asAnchor: true, to: "/", css: { width: 50 } }, { children: (0, jsx_runtime_1.jsx)("img", { css: { maxWidth: 50, height: 32 }, src: "/img/RF-logo-mobile.svg", alt: "Logo" }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", css: { flexGrow: 1, textAlign: 'center', fontSize: 16 } }, { children: title })), !!userId && !isConnectionsPage && isMenuOpen && ((0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ sx: { position: 'relative' }, onClick: closeMenu, to: "/connections/chats" }, { children: [(0, jsx_runtime_1.jsx)(ChatOutlined_1.default, { sx: { color: 'black' }, fontSize: "medium" }), (0, jsx_runtime_1.jsx)(NotificationBadge_1.default, { show: unreadChats })] }))), (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ onClick: toggleMenu, css: { height: 32, width: 36 } }, { children: isMenuOpen ? (0, jsx_runtime_1.jsx)(Close_1.default, { sx: classes.menuIcon }) : (0, jsx_runtime_1.jsx)(Menu_1.default, { sx: classes.menuIcon }) }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Link_1.default, __assign({ asAnchor: true, to: "/" }, { children: (0, jsx_runtime_1.jsx)("img", { css: {
                                        maxWidth: 200,
                                    }, src: "/img/RF-logo-full-dark.svg", alt: "Logo" }) })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexGrow: 1, gap: "4rem" }, { children: [(0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ to: "/vacancies" }, { children: trans_1.default.get('entities.vacancies') })), (0, jsx_runtime_1.jsxs)(MenuItem_1.default, __assign({ to: "/saved-vacancies" }, { children: [trans_1.default.get('labels.frontend.general.saved_vacancies'), (bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.size) ? ((0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: __assign(__assign({}, bookmarkedBubbleStyle_1.default), { position: 'absolute', top: '-10px', right: '-20px' }) }, { children: bookmarks.size }))) : ('')] })), !!userId && (0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ to: "/applications/active" }, { children: trans_1.default.get('labels.frontend.general.my_applications') }))] })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", gap: "20px" }, { children: [!!userId && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: handleClick, sx: { padding: 0 } }, { children: userImageSrc ? (0, jsx_runtime_1.jsx)(material_1.Avatar, { src: userImageSrc, sx: classes.userImage }) : (0, jsx_runtime_1.jsx)(Person_1.default, { fontSize: "large" }) })), (0, jsx_runtime_1.jsx)(AccountMenu_1.default, { open: open, handleClose: handleClose, anchorEl: anchorEl })] })), (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/vacancy-alerts" }, { children: (0, jsx_runtime_1.jsx)(MailOutline_1.default, { sx: { color: 'black' }, fontSize: "large" }) })), !userId ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ asAnchor: true, css: MenuItem_1.menuItemStyle, style: { display: 'flex', alignItems: 'center' }, to: "/login" }, { children: [trans_1.default.get('labels.frontend.auth.login_button'), (0, jsx_runtime_1.jsx)(ArrowRightIcon_1.default, { style: { marginLeft: 8, stroke: '#FF4F6B' } })] })), (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ asAnchor: true, 
                                                // css={menuItemStyle}
                                                to: "/register", css: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    height: 40,
                                                    backgroundColor: theme.palette.primary.dark,
                                                    color: 'white',
                                                    fontWeight: 'bold',
                                                    textDecoration: 'none',
                                                    borderRadius: 50,
                                                    padding: '0 20px',
                                                } }, { children: [trans_1.default.get('labels.frontend.auth.register_button'), (0, jsx_runtime_1.jsx)(ArrowRightIcon_1.default, { style: { marginLeft: 8, stroke: 'white' } })] }))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ sx: { position: 'relative' }, to: "/connections/chats" }, { children: [(0, jsx_runtime_1.jsx)(ChatOutlined_1.default, { sx: { color: 'black' }, fontSize: "large" }), (0, jsx_runtime_1.jsx)(NotificationBadge_1.default, { show: unreadChats })] })), (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ asAnchor: true, to: "/organization", css: MenuItem_1.menuItemStyle, style: { display: 'flex', alignItems: 'center', gap: 8 } }, { children: [(0, jsx_runtime_1.jsx)(Apartment_1.default, { fontSize: "large" }), trans_1.default.get('labels.frontend.general.organization_dashboard')] }))] }))] }))] })) })) })), (0, jsx_runtime_1.jsx)("div", { css: {
                    borderBottom: "1px solid ".concat(theme.palette.primary.main),
                    height: 1,
                } }), isMenuOpen && isSmallScreen && (0, jsx_runtime_1.jsx)(MobileMenu_1.default, { onLinkClicked: closeMenu })] }));
};
exports.default = TopBar;
